import { createReducer } from "actionware";
import { createState } from "stateware";
import {
  fetchProfileData,
  saveGeneralInfo,
  savePassword,
  fetchLenderProfile,
} from "./profileActions";

const initialState = createState({
  profileData: {
    userData: {
      fullName: "",
      phoneNumber: "",
      email: "",
    },
  },
  bankAccount: [],
  password: {},
  userData: null, // Add userData to the initial state
});

export default createReducer(initialState)
  .on(fetchProfileData, (state, profileData) =>
    initialState.copy({ profileData })
  )
  .on(saveGeneralInfo, (state, generalInfo) => {
    state.copy({
      profileData: {
        ...state.profileData,
        ...generalInfo,
      },
    });
  })
  .on(savePassword, (state, password) => initialState.copy({ password }))
  .onError(savePassword, (state, error) =>
    initialState.copy({ errorMessage: "your password was incorrect." })
  )
  .on(fetchLenderProfile, (state, userData) => {
    return { ...state, userData };
  });
